import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListOrdenes from './ListOrdenes';
import OrdenEdit from './OrdenEdit';

export default class AdmOrdenes extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListOrdenes/>}/>
                    <Route path="Editar/:id" element={<OrdenEdit />} />
                    <Route path="Publicacion" element={<ListOrdenes />} />
                </Routes>
            </div>
        );
    }
}